module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_8023.dc3dd171.png";